export const AppConfig = {
    domains: {
        external: process.env.NEXT_PUBLIC_PRIMARY_DOMAIN,
    },

    routes: {
        internal: {
            // Access Denied
            accessDenied: '/acesso-negado',

            // Admin
            admin: '/admin',

            // Admin - Docs
            adminDocs: '/admin/docs',

            // Admin - Comments
            adminComments: '/admin/comentarios',

            // Admin - Questions
            adminCommentsQuestions: '/admin/comentarios/perguntas/',
            adminCommentsQuestionsIdUpdate: (questionId: string) => `/admin/comentarios/perguntas/atualizar-pergunta/${questionId}`,
            adminCommentsQuestionsIdDelete: (questionId: string) => `/admin/comentarios/perguntas/remover-pergunta/${questionId}`,

            // Admin - Feedback
            adminCommentsFeedback: '/admin/comentarios/retornos',
            adminCommentsFeedbackIdUpdate: (feedbackId: string) => `/admin/comentarios/retornos/atualizar-retorno/${feedbackId}`,
            adminCommentsFeedbackIdDelete: (feedbackId: string) => `/admin/comentarios/retornos/remover-retorno/${feedbackId}`,

            // Admin - Client-Accountant
            adminAccountants: '/admin/contadores',
            adminAccountantIdClients: (accountantId: string) => `/admin/contadores/${accountantId}`,
            adminAccountantIdClientsIdUpdate: (accountantId: string, clientId: string) => `/admin/contadores/${accountantId}/atualizar-cliente/${clientId}`,
            adminAccountantIdClientsIdNew: (accountantId: string) => `/admin/contadores/${accountantId}/cadastrar-cliente`,
            adminAccountantIdClientsIdDelete: (accountantId: string, clientId: string) => `/admin/contadores/${accountantId}/remover-cliente/${clientId}`,

            // Admin - Client-Seller
            adminSellers: '/admin/vendedores',
            adminSellerIdClients: (sellerId: string) => `/admin/vendedores/${sellerId}`,
            adminSellerIdClientsIdUpdate: (sellerId: string, clientId: string) => `/admin/vendedores/${sellerId}/atualizar-cliente/${clientId}`,
            adminSellerIdClientsIdNew: (sellerId: string) => `/admin/vendedores/${sellerId}/cadastrar-cliente`,
            adminSellerIdClientsIdDelete: (sellerId: string, clientId: string) => `/admin/vendedores/${sellerId}/remover-cliente/${clientId}`,

            adminClientBackups: '/admin/backup-clientes',
            adminViewClientBackups: (client: string) => `/admin/backup-clientes/view?client=${client}`,

            adminRegistration: '/admin/cadastro-pessoal',

            // Admin - Users
            adminUsers: '/admin/usuarios',
            adminUsersIdUpdate: (userId: string) => `/admin/usuarios/atualizar-usuario/${userId}`,
            adminUsersIdLogs: (userId: string) => `/admin/usuarios/log-usuario/${userId}`,
            adminUsersNew: `/admin/usuarios/cadastrar-usuario`,
            adminUsersIdDelete: (userId: string) => `/admin/usuarios/remover-usuario/${userId}`,

            // Admin - Visitors
            adminVisitors: '/admin/visitantes',
            adminVisitorsIdUpdate: (visitorId: string) => `/admin/visitantes/atualizar-visitante/${visitorId}`,
            adminVisitorsIdDelete: (visitorId: string) => `/admin/visitantes/remover-visitante/${visitorId}`,

            // Client
            client: '/cliente',
            clientRegistration: '/cliente/cadastro-pessoal',

            // Accountant
            accountant: '/contador',
            accountantClients: '/contador/clientes',
            accountantViewClients: (client: string) => `/contador/clientes/view?client=${client}`,
            accountantRegistration: '/contador/cadastro-pessoal',

            // Seller
            seller: '/vendedor',
            sellerRegistration: '/vendedor/cadastro-pessoal',

            home: '/',
        },
        external: {
            home: '/',
            login: '/login',
            blog: '/blog',
            products: `/produtos`,
            business: '/quem-somos',
            copyright: '/copyright',
            segmentsDis: '/segmentos/distribuidoras',
            segmentsFac: '/segmentos/industrias',
            segmentsRur: '/segmentos/produtor-rural',
            segmentsSer: '/segmentos/servicos',
            segmentsSto: '/segmentos/varejo',
            blogSend: '/blog/enviar-comentario',
        },
    }
}

export type InternalRoute = keyof typeof AppConfig.routes.internal;
export type ExternalRoute = keyof typeof AppConfig.routes.external;
export type DomainType = keyof typeof AppConfig.domains;